<template>
<v-dialog v-model="dialogWebviewbig_ocr" persistent style="overflow-y: hidden; border-radius:20px;" fullscreen>
  <v-card style="border-radius:20px;width: 70vw;margin: auto;overflow-y: hidden; ">
    <v-card tile>
      <v-app-bar flat style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai">&nbsp;&nbsp;{{$t('Dialog.ocr.selectText')}} </v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn dark icon text @click.native="newtab">
          <v-icon style="color: white !important; font-size: 20px !important;">far fa-window-restore</v-icon>
        </v-btn> -->
        <v-btn dark icon text @click.native="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
    </v-card>
    <v-card-text style="padding: 0; height: 550px !important;">
      <iframe style="visibility:visible; width: 100% !important; height: 100% !important;" frameborder='0' :src="Webview_item.url" allow="geolocation" v-if="!progressLoding"></iframe>
      <!-- <v-progress-linear v-else  v-model="value" style="width: 60vw !important; margin: auto;" height="20" background-color="#80a7d8" color="#0e468e" >
        <strong style="color: white !important; justify-content: center;text-align: center;display: flex;">{{ Math.ceil(value) }}%</strong>
      </v-progress-linear> -->
      <v-layout wrap v-else>
        <v-flex sm12 md12 lg12 xl12 style="justify-content: center; display: grid;height: 80vh;">
          <div style="margin: auto;">
            <v-progress-circular :rotate="-90" :size="150" :width="15" :value="value" color="#0e468e" style="width: 60vw !important;">
              {{ Math.ceil(value) }}%
            </v-progress-circular>
            <br />
            <br />
            <h3 style="text-align: center;">{{$t('Dialog.ocr.processing')}}</h3>
          </div>
        </v-flex>
      </v-layout>
      <!-- <iframe width="500" height="550" style="visibility:visible;" frameborder='0' src="https://etaxgateway.one.th/webfooddelivery?authorize=3045279722" allow="geolocation"></iframe>
 -->
    </v-card-text>
  </v-card>
</v-dialog>
</template>
<script>
import {
  sync
} from 'vuex-pathify'
export default {
  data() { // <== changed this line
    return {
      progressLoding: true,
      interval: 0,
      value: 0,
      // tokenroom: String,
      // tokenuser: String
    }
  },
  props: {
    dialogWebviewbig_ocr: false,
    Webview_item: {},
    tokenroom: String,
    tokenuser: String
  },
  watch: {
    socket_close_webview() {
      this.closeDialog()
    },
    dialogWebviewbig_ocr() {
      if (this.dialogWebviewbig_ocr) {
        // console.log(this.tokenuser)
        // console.log(this.tokenroom)
        this.queryAndIndeterminate()
      } else {
        this.value = 0
        this.progressLoding = true
      }
    },
    Webview_item() {
      this.value = 100
      this.interval = 0
      this.progressLoding = false
    }
  },
  computed: {
    ...sync('*')
  },
  methods: {
    queryAndIndeterminate() {
      this.value = 0

      // setTimeout(() => {
      var step = 0.3
      var current_progress = 0
      var me = this
      this.interval = setInterval(function() {
        current_progress += step;
        me.value = Math.round(Math.atan(current_progress) / (Math.PI / 2) * 100 * 1000) / 1000
        if (me.value >= 100) {
          clearInterval(me.interval)
        } else if (me.value >= 70) {
          step = 0.1
        }
      }, 100)
      // }, 2500)
    },
    closeDialog() {
      // console.log("closeDialog")
      this.$emit('closewebview', false)
      this.progressLoding = true
      this.closewebview()
    },
    closewebview() {
      // console.log(authen.tokenuser)
      this.axios.post(process.env.VUE_APP_API_alpine + `/v1/close-webview`, {
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser
      }).then((response) => {
        // console.log(response.data)
        // this.closeDialog()
      }).catch(error => {
        console.log(error)
      })
    },
    newtab() {
      // this.Webview_item.url
      window.open(this.Webview_item.url, '_blank')
      this.closeDialog()
    }
  }
}
</script>
<style type="text/css" scoped>

</style>
